module.exports = __webpack_public_path__ + "img/bm.b357ea5c.png";